<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DeleteApiKey',
  props: {
    apiKey: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      progress: false,
    }
  },
  computed: {
    ...mapState('ui', ['elasticUpdateDelay']),
  },
  methods: {
    ...mapActions('apiKeys', [
      'deleteApiKey',
    ]),
    async onSubmit() {
      this.progress = true
      const { apiKey: { id } } = this
      const response = await this.deleteApiKey({ id })
      const [error] = response

      this.$notifier({
        response,
        successMsg: 'API Key successfully deleted',
      })


      if (error) {
        this.progress = false
      } else {
        // NOTE Wait becase backend need a second for update data
        // It's temporary solution, time will be tuned
        setTimeout(() => {
          this.progress = false
          this.$router.replace({
            name: 'api-keys',
          })
        }, this.elasticUpdateDelay)
      }
    },
  },
}
</script>

<template>
  <state-dialog
    title="Delete API Key"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <el-icon
      slot="icon"
      name="warning"
    />
    <el-icon
      slot="subicon"
      name="delete"
    />
    <template slot="message">
      Are you sure you wish to delete this API key?
    </template>

    <div class="modal__footer">
      <el-button
        type="danger"
        :loading="progress"
        class="el-button--wide"
        @click.stop="onSubmit"
      >
        Delete
      </el-button>
    </div>
  </state-dialog>
</template>
